import type { AdminBudgetItem } from "@shared/schema";

export interface BudgetStatusInfo {
  label: string;
  color: string;
}

const STATUS_STEPS: { key: keyof AdminBudgetItem; info: BudgetStatusInfo }[] = [
  { key: "invoicePaid", info: { label: "INV Paid", color: "bg-green-900/40 text-green-400 border border-green-800" } },
  { key: "invoiceSent", info: { label: "INV Sent", color: "bg-indigo-900/40 text-indigo-300 border border-indigo-800" } },
  { key: "invoiceCreated", info: { label: "INV Created", color: "bg-purple-900/40 text-purple-300 border border-purple-800" } },
  { key: "bidApproved", info: { label: "BID Approved", color: "bg-emerald-900/40 text-emerald-400 border border-emerald-800" } },
  { key: "bidRejected", info: { label: "BID Rejected", color: "bg-red-900/40 text-red-400 border border-red-800" } },
  { key: "bidSent", info: { label: "BID Sent", color: "bg-blue-900/40 text-blue-300 border border-blue-800" } },
];

const DRAFT_STATUS: BudgetStatusInfo = {
  label: "Draft",
  color: "bg-gray-800 text-gray-400 border border-gray-700",
};

export function getActiveStatus(item: AdminBudgetItem): BudgetStatusInfo {
  for (const step of STATUS_STEPS) {
    if (item[step.key]) return step.info;
  }
  return DRAFT_STATUS;
}

